<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">Student Life</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">Student Life</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="ptb--100 ">
    <div class="container">
        <div class="row justify-content-center gx-4 gy-3">
            <div class="col-md-3">
                <h4 class="yellow-color fw-bold mb-2">Antaragni</h4>
                <div class="student-life" data-bs-toggle="modal" data-bs-target="#antaragni">
                    <img class="img-fluid" src="{{baseUrl}}/gallery/a1.webp" alt="Antaragni|GHRCACS">
                    <div class="demo-gallery-poster">
                        <h6>Antaragni</h6>
                        <i class="fa fa-search-plus"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <h4 class="yellow-color fw-bold mb-2">Debate Compitition</h4>
                <div class="student-life" data-bs-toggle="modal" data-bs-target="#debate">
                    <img class="img-fluid" src="{{baseUrl}}/gallery/d_1.webp" alt="Debate Compitition|GHRCACS">
                    <div class="demo-gallery-poster">
                        <h6>Debate Compitition</h6>
                        <i class="fa fa-search-plus"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <h4 class="yellow-color fw-bold mb-2">Industrial tour</h4>
                <div class="student-life" data-bs-toggle="modal" data-bs-target="#industrial-tour">
                    <img class="img-fluid" src="{{baseUrl}}/gallery/i_1.webp" alt="Industrial tour|GHRCACS">
                    <div class="demo-gallery-poster">
                        <h6>Industrial tour</h6>
                        <i class="fa fa-search-plus"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <h4 class="yellow-color fw-bold mb-2">NSS</h4>
                <div class="student-life" data-bs-toggle="modal" data-bs-target="#nss">
                    <img class="img-fluid" src="{{baseUrl}}/gallery/n_1.webp" alt="NSS|GHRCACS">
                    <div class="demo-gallery-poster">
                        <h6>NSS</h6>
                        <i class="fa fa-search-plus"></i>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <h4 class="yellow-color fw-bold mb-2">Sports</h4>
                <div class="student-life" data-bs-toggle="modal" data-bs-target="#sports">
                    <img class="img-fluid" src="{{baseUrl}}/gallery/s_1.webp" alt="Sports|GHRCASC">
                    <div class="demo-gallery-poster">
                        <h6>Sports</h6>
                        <i class="fa fa-search-plus"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="modal fade" id="antaragni">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body text-center">
                <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <div class="row">
                    <h5 class="modal-title" id="antaragni">Antaragni</h5>
                    <ul class="lightgallery list-unstyled row g-2 row-cols-2 row-cols-lg-4 justify-content-center">
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a1.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a1.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/a1.webp"
                                    alt="Antaragni|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a2.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a2.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/a2.webp"
                                    alt="Antaragni|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a3.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a3.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/a3.webp"
                                    alt="Antaragni|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a4.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a4.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/a4.webp"
                                    alt="Antaragni|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a5.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a5.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/a5.webp"
                                    alt="Antaragni|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a6.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/a6.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/a6.webp"
                                    alt="Antaragni|GHRCACS">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="debate">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body text-center">
                <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <div class="row">
                    <h5 class="modal-title" id="debate">Debate Compitition</h5>
                    <ul class="lightgallery list-unstyled row g-2 row-cols-2 row-cols-lg-4 justify-content-center">
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_1.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_1.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_1.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_2.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_2.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_2.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_3.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_3.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_3.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_4.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_4.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_4.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_5.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_5.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_5.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_6.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_6.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_6.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_7.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/d_7.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/d_7.webp"
                                    alt="Debate Compitition|GHRCACS">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="industrial-tour">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body text-center">
                <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <div class="row">
                    <h5 class="modal-title" id="debate">Industrial tour</h5>
                    <ul class="lightgallery list-unstyled row g-2 row-cols-2 row-cols-lg-4 justify-content-center">
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_1.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_1.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/i_1.webp"
                                    alt="Industrial tour|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_2.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_2.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/i_2.webp"
                                    alt="Industrial tour|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_3.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_3.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/i_3.webp"
                                    alt="Industrial tour|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_4.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_4.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/i_4.webp"
                                    alt="Industrial tour|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_5.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_5.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/i_5.webp"
                                    alt="Industrial tour|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_6.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/i_6.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/i_6.webp"
                                    alt="Industrial tour|GHRCACS">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="nss">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body text-center">
                <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <div class="row">
                    <h5 class="modal-title" id="debate">NSS</h5>
                    <ul class="lightgallery list-unstyled row g-2 row-cols-2 row-cols-lg-4 justify-content-center">
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_1.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_1.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/n_1.webp"
                                    alt="NSS|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_2.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_2.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/n_2.webp"
                                    alt="NSS|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_3.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_3.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/n_3.webp"
                                    alt="NSS|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_4.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_4.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/n_4.webp"
                                    alt="NSS|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_5.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_5.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/n_5.webp"
                                    alt="NSS|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_6.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/n_6.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/n_6.webp"
                                    alt="NSS|GHRCACS">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="sports">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body text-center">
                <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <div class="row">
                    <h5 class="modal-title" id="debate">Sports</h5>
                    <ul class="lightgallery list-unstyled row g-2 row-cols-2 row-cols-lg-4 justify-content-center">
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/s_1.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/s_1.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/s_1.webp"
                                    alt="Sports|GHRCACS">
                            </a>
                        </li>
                        <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/s_2.webp"
                            data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/gallery/s_2.webp">
                            <a href="International trip-Bhutan">
                                <img class="img-responsive img-fluid" src="{{baseUrl}}/gallery/s_2.webp"
                                    alt="Sports|GHRCACS">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
